import useSWR from 'swr'
import { api } from '@/api'
import { Link } from 'react-router-dom'
import { formatDate } from '@/utils'

export default function AdminDashboard() {
  const { data: summaryData } = useSWR('/admin/summary', () => api.admin.getSummary())
  const { data: appointmentsData } = useSWR('/appointments?limit=10', () => 
    api.appointments.getAll({ limit: 10 })
  )

  const summary = summaryData?.data || {}
  const recentAppointments = appointmentsData?.data || []

  const getStatusColor = (status: string) => {
    const colors: Record<string, string> = {
      pending: 'bg-yellow-100 text-yellow-800',
      confirmed: 'bg-green-100 text-green-800',
      completed: 'bg-blue-100 text-blue-800',
      cancelled: 'bg-red-100 text-red-800',
    }
    return colors[status] || 'bg-gray-100 text-gray-800'
  }

  const getStatusLabel = (status: string) => {
    const labels: Record<string, string> = {
      pending: '待确认',
      confirmed: '已确认',
      completed: '已完成',
      cancelled: '已取消',
    }
    return labels[status] || status
  }

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-900 mb-4">管理概览</h2>

      {/* 统计卡片 */}
      <div className="grid grid-cols-3 gap-3 mb-6">
        <Link to="/admin/appointments" className="card text-center hover:shadow-md transition-shadow">
          <p className="text-2xl font-bold text-primary-600">{summary.today || 0}</p>
          <p className="text-xs text-gray-500">今日预约</p>
        </Link>
        <Link to="/admin/appointments?filter=pending" className="card text-center hover:shadow-md transition-shadow">
          <p className="text-2xl font-bold text-yellow-600">{summary.pending || 0}</p>
          <p className="text-xs text-gray-500">待确认</p>
        </Link>
        <Link to="/admin/appointments?filter=confirmed" className="card text-center hover:shadow-md transition-shadow">
          <p className="text-2xl font-bold text-green-600">{summary.confirmed || 0}</p>
          <p className="text-xs text-gray-500">已确认</p>
        </Link>
      </div>

      {/* 最近预约 */}
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-semibold text-gray-900">最近预约</h3>
        <Link to="/admin/appointments" className="text-sm text-primary-600 hover:text-primary-700">
          查看全部 →
        </Link>
      </div>
      
      <div className="space-y-2">
        {recentAppointments.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <p>暂无预约记录</p>
            <Link to="/admin/appointments" className="text-primary-600 hover:text-primary-700 text-sm mt-2 inline-block">
              去查看预约管理
            </Link>
          </div>
        ) : (
          recentAppointments.map(apt => (
            <Link
              key={apt.id}
              to={`/admin/appointments?date=${apt.appointment_date}`}
              className="card py-3 hover:shadow-md hover:bg-primary-50 transition-all block"
            >
              <div className="flex justify-between items-center">
                <div>
                  <p className="font-medium text-gray-900">{apt.customer_name}</p>
                  <p className="text-sm text-gray-500">{apt.service?.name || '预约服务'}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-900">{formatDate(apt.appointment_date)}</p>
                  <p className="text-xs text-gray-500">{apt.appointment_time}</p>
                  <span className={`inline-block mt-1 px-2 py-0.5 rounded-full text-xs ${getStatusColor(apt.status)}`}>
                    {getStatusLabel(apt.status)}
                  </span>
                </div>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  )
}
